module.exports = __webpack_public_path__ + "img/y_2021_1_hover.1ee49ac0.png";